import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getGeneralDonationData } from '../config/firebase';

export function DonationLanding() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const checkAuth = async () => {
      // Si l'utilisateur n'est pas connecté
      if (!user) {
        // Sauvegarder l'ID de la donation dans le localStorage
        localStorage.setItem('pendingDonationId', id || '');
        // Rediriger vers la page de connexion
        navigate('/login', { 
          state: { 
            message: "Connectez-vous ou inscrivez-vous pour voir cette donation",
            returnUrl: `/donation/${id}`
          }
        });
        return;
      }

      // Si l'utilisateur est connecté, récupérer les données de la donation
      const donationData = await getGeneralDonationData();
      if (donationData) {
        // Rediriger vers la page d'accueil avec la donation active
        navigate('/', { state: { showDonation: true } });
      }
    };

    checkAuth();
  }, [id, user, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="text-white text-center">
        <p>Chargement...</p>
      </div>
    </div>
  );
} 